<script setup>
const props = defineProps({ 
  isLargeScreen : Boolean
})
</script>

<template>
  <template v-if="props.isLargeScreen">
    <!-- PC -->
    <div id="ads-ADU-20PG6C49"></div>
    <script>
      (function(w,d,s,i){w.adunitlength?w.adunitlength.push('ADU-20PG6C49'):w.adunitlength=['ADU-20PG6C49'];var f=d.getElementsByTagName(s)[0],j=d.createElement(s);
      j.async=true;j.src='https://rise.enhance.co.jp/adu.js?id='+i + '&matwName=matw_uuid' + '&clientTime=' + (new Date()).getTime();
      f.parentNode.insertBefore(j,f);})(window,document,'script','ADU-20PG6C49');
    </script>
  </template>
  <template v-else>
    <!-- SP -->
    <div id="ads-ADU-6AM1EH1T"></div>
    <script>
      (function(w,d,s,i){w.adunitlength?w.adunitlength.push('ADU-6AM1EH1T'):w.adunitlength=['ADU-6AM1EH1T'];var f=d.getElementsByTagName(s)[0],j=d.createElement(s);
      j.async=true;j.src='https://rise.enhance.co.jp/adu.js?id='+i + '&matwName=matw_uuid' + '&clientTime=' + (new Date()).getTime();
      f.parentNode.insertBefore(j,f);})(window,document,'script','ADU-6AM1EH1T');
    </script>
  </template>
</template>

<style scoped>
</style>